import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const rows = gsap.utils.toArray('.gallery-row');

rows.forEach((row, index) => {
  const direction = index % 2 === 0 ? 1 : -1;
  const totalWidth = Array.from(row.children).reduce((acc, child) => acc + child.offsetWidth, 0);
  const rowWidth = row.offsetWidth;
  const distanceToScroll = totalWidth - rowWidth;

  gsap.to(row, {
    x: -distanceToScroll * direction,
    ease: "none",
    scrollTrigger: {
      trigger: row,
      start: "top bottom",
      end: "bottom top",
      scrub: 8,
      invalidateOnRefresh: true
    }
  });
});
